(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-finder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const finder = document.querySelector('.gift-finder');
    if (!finder) return;

    const recipientSelect = finder.querySelector('#GiftRecipientSelect');
    const personalitySelect = finder.querySelector('#GiftPersonalitySelect');
    const priceSelect = finder.querySelector('#GiftPriceSelect');
    const collectionSection = document.querySelector('[data-section-type="collection"]');
    const gridContainer = collectionSection?.querySelector('[data-products-grid]');

    // Helper: Build Shopify filter URL
function buildUrl() {
  const baseUrl = finder.dataset.url;
  const params = new URLSearchParams();

  // Combine both dropdowns into the same filter param (OR logic)
  const combinedValues = [recipientSelect.value, personalitySelect.value].filter(Boolean);
  combinedValues.forEach(val => {
    params.append('filter.p.m.custom.gift_personality', val);
  });

  // Handle price filters
  if (priceSelect?.value && priceSelect.value.includes('filter.v.price')) {
    const priceParams = new URLSearchParams(priceSelect.value.split('?')[1]);
    priceParams.forEach((v, k) => params.append(k, v));
  }

  return `${baseUrl}?${params.toString()}`;
}


    // Helper: Fetch & replace product grid via AJAX
    async function updateGrid() {
      const url = buildUrl();
      if (!gridContainer) return;

      gridContainer.classList.add('is-loading');
      gridContainer.style.opacity = 0.3;

      try {
        const response = await fetch(`${url}&section_id=${collectionSection.dataset.sectionId}`);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newGrid = html.querySelector('[data-products-grid]');

        if (newGrid) {
          gridContainer.innerHTML = newGrid.innerHTML;
        }

        // Update browser URL without reload
        window.history.replaceState({}, '', url);
      } catch (err) {
        console.error('Gift Finder update failed:', err);
      } finally {
        gridContainer.classList.remove('is-loading');
        gridContainer.style.opacity = 1;
      }
    }

    // Helper: Pre-select options based on URL query parameters
    function initializeSelectionsFromUrl() {
      const params = new URLSearchParams(window.location.search);

      // Recipient
      const recipientVal = params.get('filter.p.m.custom.gift_recipient');
      if (recipientSelect && recipientVal) recipientSelect.value = recipientVal;

      // Personality
      const personalityVal = params.get('filter.p.m.custom.gift_personality');
      if (personalitySelect && personalityVal) personalitySelect.value = personalityVal;

      // Price
      const gte = params.get('filter.v.price.gte');
      const lte = params.get('filter.v.price.lte');

      if (priceSelect) {
        if (gte === '40' && lte === '70') {
          priceSelect.value = '?filter.v.price.gte=40&filter.v.price.lte=70';
        } else if (lte === '40') {
          priceSelect.value = '?filter.v.price.lte=40';
        } else if (gte === '70') {
          priceSelect.value = '?filter.v.price.gte=70';
        } else {
          priceSelect.value = '';
        }
      }
    }

    // Initialize selects from URL params
    initializeSelectionsFromUrl();

    // Listen for filter changes
    [recipientSelect, personalitySelect, priceSelect].forEach((sel) => {
      sel?.addEventListener('change', () => {
        // If "show me everything" is chosen on price, only clear price filter
        if (sel === priceSelect && priceSelect.value === finder.dataset.url) {
          priceSelect.value = '';
        }

        updateGrid();
      });
    });

    // Handle browser back/forward navigation
    window.addEventListener('popstate', () => {
      initializeSelectionsFromUrl();
      updateGrid();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
